import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";

   const GetReportsListItem=(params:any)=>request({
    url: ApiURL.Query.GetReportsListItem+"/"+params,
    method: RequestType.GET,
   });
   const GetListOfSelfReportsListItem=()=>request({
    url: ApiURL.Query.GetListOfSelfReportsListItem,
    method: RequestType.GET,
   });
   const GetListOfReportsListItem=()=>request({
    url: ApiURL.Query.GetListOfReportsListItem,
    method: RequestType.GET,
   });
   const GetListOfReportsAuthorization=(params:any)=>request({
    url: ApiURL.Query.GetListOfReportsAuthorization+"/"+params,
    method: RequestType.GET,
    params
   });
   
   const ReportsQuery = {
    GetReportsListItem,
    GetListOfSelfReportsListItem,
    GetListOfReportsListItem,
    GetListOfReportsAuthorization
  };
  
  export default ReportsQuery;